<template>
	<v-card class="elevation-0">
		<v-row>

      <v-col cols="12">
      	<v-card class="shadowCard">
      		<v-card-text class="black--text">
		        <span ><b>Alumno:</b> {{ alumno.nombre }} <br/></span>
		        <span ><b>Matricula:</b> {{ alumno.matricula }} <br/></span>
		        <span ><b>Grupo:</b> {{ steppers.grupo.grupoActual.grupo }} <br/></span>

		        <v-divider class="my-2"></v-divider>

		        <label><b>Datos generales del pago</b></label>
						<v-list class="transparent" dense>
				      <v-list-item class="pa-0">
				        <v-list-item-title align="end" class="pr-2">
		              Costo del curso:
		            </v-list-item-title>

				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ precio_inicial }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider></v-divider>

				      <v-list-item class="pa-0" v-if="descuento">
				        <v-list-item-title align="end" class="pr-2">
		              Desc. pronto pago:
		            </v-list-item-title>

				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ descuento }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="descuento"></v-divider>

				      <v-list-item class="pa-0" v-if="descRecomienda">
				        <v-list-item-title align="end" class="pr-2">
		              Recomendados:
		            </v-list-item-title>
				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ descRecomienda }}</b>
                  <span v-if="descRecomiendaSaldo" class="grey--text text-caption"> · saldo ${{ descRecomiendaSaldo }}</span>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="descRecomienda"></v-divider>

		          <v-list-item class="pa-0" v-if="descuentoHermanos">
		            <v-list-item-title align="end" class="pr-2">
		              Descuento Hmnos:
		            </v-list-item-title>

		            <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
		              <b>$ {{ descuentoHermanos }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="descuentoHermanos"></v-divider>


		          <v-list-item class="pa-0" v-if="pago_anterior">
		            <v-list-item-title align="end" class="pr-2">
		              Pago anterior:
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
		              <b>$ {{ pago_anterior }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="pago_anterior"></v-divider>

		          <v-list-item class="pa-0" v-if="solcitaFactura">
		            <v-list-item-title align="end" class="pr-2">
		              <b>Subtotal:</b>
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="text-h6 black--text">
		              <b>$ {{ parseFloat( pago_anterior ) }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="solcitaFactura"></v-divider>

		          <v-list-item class="pa-0" v-if="solcitaFactura">
		            <v-list-item-title align="end" class="pr-2">
		              <b>IVA:</b>
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="text-h6 black--text">
		              <b>$ {{ parseFloat( iva ) + ivaBonoIaApp }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="solcitaFactura"></v-divider>

				      <v-list-item class="pa-0" v-if="bonoIaApp">
				        <v-list-item-title align="end" class="pr-2">
		              <b>Pago + IA:</b>
		            </v-list-item-title>
		            <v-list-item-subtitle class="text-h6 black--text">
				          <b>$ {{ montoBonoIaApp }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="bonoIaApp"></v-divider>

				      <v-list-item class="pa-0">
				        <v-list-item-title align="end" class="pr-2">
		              <b>Total a pagar:</b>
		            </v-list-item-title>
				        
		            <v-list-item-subtitle class="text-h6 black--text">

				          <b>$ {{ pagoFinal }}</b>
		            	
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider></v-divider>

			      <v-list-item class="pa-0">
			        <v-list-item-title align="end" class="pr-2">
	              <b>Total pagado:</b>
	            </v-list-item-title>

			        <v-list-item-subtitle class="text-h4 black--text" v-if="tipo_pago != 1">
	              <v-tooltip bottom color="blue" max-width="300">
	                <template v-slot:activator="{ on, attrs }">
	                  <v-text-field
	                    v-if="vistaPrevia"
	                    dense
	                    type="number"
	                    v-model="total_pagado"
	                    v-bind="attrs"
	                    v-on="on"
	                  ></v-text-field>
	                </template>
	                <span>Ingresa el monto que el cliente pagó</span>
	              </v-tooltip>
	            </v-list-item-subtitle>

			        <v-list-item-subtitle class="text-h4 black--text" v-else>
			          <v-tooltip bottom color="blue" max-width="300">
			            <template v-slot:activator="{ on, attrs }">
			              <v-text-field
			                dense
			                type="number"
			                v-model="total_pagado"
			                v-bind="attrs"
			                v-on="on"
			              ></v-text-field>
			            </template>
			            <span>Ingresa el monto que el cliente pagó</span>
			          </v-tooltip>
			        </v-list-item-subtitle>
			      </v-list-item>
		          <v-divider></v-divider>
				    </v-list>
      		</v-card-text>
      	</v-card>
			</v-col>

	    <v-divider class="my-4"></v-divider>
	    <v-row>
	    	<v-col cols="12" class="px-8">
	    		<v-card class="shadowCard">
	    		  <v-card-text>
	    		    <v-row>
								<v-col cols="12" md="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<label v-bind="attrs" v-on="on"><b>Selecciona la forma de pago</b></label>
						</template>
						<span>Elige el método de pago del cliente (Contado o Pagos)</span>
					</v-tooltip>

						<v-radio-group
					      v-model="tipo_pago"
					      column
					      readonly
					    >
					      <v-radio
					      	v-for="(item, i) in tipos_pago"
					      	:key="i"
					        :label="item.tipo"
					        :value="item.id"
					      ></v-radio>
					    </v-radio-group>


				    <!-- SOLICITAR FACTURA -->
		        <v-tooltip bottom color="blue" max-width="300" v-if=" ( ((parseFloat(total_a_pagar) - parseFloat(pago_anterior)  - parseFloat(descuentoHermanos)  ) + parseFloat(saldoFactura)) - total_pagado ) <= 0 || solcitaFactura">
		          <template v-slot:activator="{ on, attrs }">
		            <span v-bind="attrs" v-on="on" style="display: inline-block;">
		              <v-checkbox 
		                label="Con Factura" 
		                v-model="solcitaFactura" 
		                :value="1"
		                small
		                dense
		              ></v-checkbox>
		            </span>
		          </template>
		          <span>Marca si el cliente solicita factura fiscal</span>
		        </v-tooltip>

		

						    <div>
						    	<v-tooltip bottom color="blue" max-width="300" v-if=" ( pagoFinal - total_pagado ) <= 0 ">
						    		<template v-slot:activator="{ on, attrs }">
							    	<v-btn 
					            color="green" 
					            dark 
					            small 
					            class="mr-2 text-capitalize" 
					            tile
					            v-bind="attrs"
					            v-on="on"
					          >
					            <v-icon small left>mdi-check-circle</v-icon>
					            Liquidado
					          </v-btn>
						    		</template>
						    		<span>El pago está completo y el alumno queda sin adeudo</span>
						    	</v-tooltip>
						    	
						    	<v-tooltip bottom color="blue" max-width="300" v-if="beca">
						    		<template v-slot:activator="{ on, attrs }">
					          <v-btn color="green" dark small class="text-capitalize" v-bind="attrs" v-on="on">Beca del {{ beca.becaTotal }}% </v-btn>
						    		</template>
						    		<span>El alumno cuenta con una beca aplicada a su inscripción</span>
						    	</v-tooltip>
						    </div>

						    <v-tooltip bottom color="blue" max-width="300" v-if="[28,334].includes( getdatosUsuarioERPERP.iderp )">
						        <template v-slot:activator="{ on, attrs }">
						          <v-btn 
						            color="orange"
						            dark
						            class="mb-6 mt-2"
						            tile
						            small
						            @click="getPrecioPagar()"
						            v-bind="attrs"
						            v-on="on"
						          >
						            <v-icon left small>mdi-cash-lock-open</v-icon>
						            Calcular costo
						          </v-btn>
						        </template>
						        <span>Calcula el monto final considerando descuentos y promociones</span>
						      </v-tooltip>

								</v-col>

								<v-col cols="12" md="6" v-if="tipo_pago">
					        <v-card-text align="center" class="pa-0">
					          <div v-if="!file">
					            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
					              <div class="dropZone-info" @drag="onChange">
					                <span class="fa fa-cloud-upload dropZone-title"></span>
					                <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
					                <div class="dropZone-upload-limit-info">
					                  <div>Extensión: png, jpg, jpeg, svg</div>
					                  <div>Tamaño máximo: 10 MB</div>
					                </div>
					              </div>
					              <input type="file" @change="onChange">
					            </div>
					          </div>

					          <v-tooltip bottom color="blue" max-width="300" v-if="file">
				            <template v-slot:activator="{ on, attrs }">
				              <v-btn color="red" class="mb-2" dense @click="removeFile" fab small dark v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
				            </template>
				            <span>Eliminar el comprobante de pago cargado</span>
				          </v-tooltip>
					          <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
					        </v-card-text>

								</v-col>

								<ReciboContactoCampos
									v-if="alumno"
									:email="alumno.email"
									:id-alumno="alumno.id_alumno"
									:cargando="cargar"
									@update:email="val => alumno.email = val"
									@actualizar-correo="actualizarCorreoAlumnoRegistrado({ id_alumno: alumno.id_alumno, email: alumno.email, alumno })"
								/>

								<v-col cols="12" v-if="tipo_pago && tipo_pago != 1">
							    <v-row>
							    	<v-col cols="12" md="4">
							    		<label>Aut. Clave Rastreo</label>
							    		<v-tooltip bottom color="blue" max-width="300">
							    			<template v-slot:activator="{ on, attrs }">
								          <v-text-field
								            filled
								            dense
								            single-line
								            v-model="aut_clave_rastreo"
								            v-bind="attrs"
								            v-on="on"
								          ></v-text-field>
							    			</template>
							    			<span>Ingresa la autorización o clave de rastreo de la transferencia</span>
							    		</v-tooltip>
							    	</v-col>

							    	<v-col cols="12" md="4">
						          <label>Folio Oper.</label>
						          <v-tooltip bottom color="blue" max-width="300">
						          	<template v-slot:activator="{ on, attrs }">
							          <v-text-field
							            filled
							            dense
							            single-line
							            v-model="folio_operacion"
							            v-bind="attrs"
							            v-on="on"
							          ></v-text-field>
						          	</template>
						          	<span>Ingresa el número de folio de la operación bancaria</span>
						          </v-tooltip>
							    	</v-col>

							    	<v-col cols="12" md="4">
						          <label>Cuenta</label>
						          <v-tooltip bottom color="blue" max-width="300">
						          	<template v-slot:activator="{ on, attrs }">
							          <v-text-field
							            filled
							            dense
							            single-line
							            v-model="cuenta"
							            v-bind="attrs"
							            v-on="on"
							          ></v-text-field>
						          	</template>
						          	<span>Ingresa la cuenta bancaria donde se depositó</span>
						          </v-tooltip>
							    	</v-col>
							    </v-row>
								</v-col>
	    		    </v-row>
	    		  </v-card-text>
	    		</v-card>
	    	</v-col>
	    </v-row>

		</v-row>

    <v-row v-if="parseFloat(pagoFinal) != parseFloat(total_pagado) ">
      <v-col cols="12">
        <v-alert
          dense
          outlined
          type="error"
        >
          Se tiene que agregar el total de la factura
        </v-alert>
      </v-col>
    </v-row>

		<v-card-actions class="pb-0 mt-6">
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="black"
            dark
            @click="steppers.paso = 2"
            tile
            small
            class="text-capitalize"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-chevron-double-left</v-icon>
            regresar
          </v-btn>
        </template>
        <span>Volver al paso de selección de grupo</span>
      </v-tooltip>
      <v-spacer></v-spacer>

      <!-- Botón de procesar -->
      <v-tooltip bottom color="blue" max-width="300" v-if="parseFloat(pagoFinal) == parseFloat(total_pagado)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            small
            dark
            class="text-capitalize"
            @click="procesarPago()"
            tile
            :disabled="cargar"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-cash-check</v-icon>
            Procesar
          </v-btn>
        </template>
        <span>Procesar el pago de la factura e inscribir al alumno</span>
      </v-tooltip>
    </v-card-actions>

    <!-- DIALOGO PARA CONFIRMAR EL CORREO DEL ALUMNO -->
    <v-dialog
      v-model="dialogConfirmaCorreo"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          Correo a donde se enviará el recibo de pago
        </v-card-title>
        <v-card-text>
          <v-text-field
            name="name"
            label="label"
            id="id"
            v-model="alumno.email"
            filled
            v-if="alumno"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            @click="dialogConfirmaCorreo = false, $emit('terminarProceso')"
            tile
            dark
            small
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="enviarComprobante()"
            tile
            dark
            small
          >
            <v-icon left small>mdi-content-save</v-icon>
            Actualizar y enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO PARA CONFIRMAR EL CORREO DEL ALUMNO -->
    <v-dialog
      v-model="dialogSiguientepago"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          Deseas realizar el pago del siguiente hermano? 
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            @click="cancelar()"
            rounded
            dark
            small
          >
            NO
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="dialogSiguientepago = false"
            rounded
            dark
            small
          >
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import leerImagenes    from '@/mixins/leerImagenes'
  import bonoIaApp       from '@/mixins/bonoIaApp'
  import inscripcionReciboContacto from '@/mixins/inscripcionReciboContacto'
  import ReciboContactoCampos from '@/components/inscripciones/ReciboContactoCampos.vue'

  const convertir = require('numero-a-letras');
  import { jsPDF } from "jspdf";
	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      ReciboContactoCampos,
    },

    mixins: [ validarErrores, leerImagenes, inscripcionReciboContacto, bonoIaApp ],

  	props:[
			'hermanos',
			'steppers',
			'tutor',
			'alumno',
			'dialogAddAlumno'
	  ],

    data: () => ({
    	escuela: 2,

			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      precio_inicial:0,
			descuento:0,
			total_a_pagar:0,

			tipo_pago: 1,

			sucursal:null,
			total_pagado:0,

			iva: 0,
			label:'',
      archivos:null,
      vistaPrevia: null,
      textoImagen:'',
      monto_imagen: 0,
      monto:0,
      isPracticaja: false,
      isTransferencia:false,
      isSeven: false,
      isOXXO: false,
      isWeb:false,
      isTarjeta:false,
      isSantander: false,
      isDirectoBancoBBVA: false,
      isDirectoBANREGIO: false,
      file: '',
      dragging: false,
      pago_anterior:0,
      banco:'',

      texto_completo:'',

      saldoFavor: 0,
      tieneSaldoFavor: false,

      fechapago: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      tipos_pago:[
      	{ id: 1, tipo: 'EFECTIVO'},
      	{ id: 2, tipo: 'DEPOSITO / TRANSFERENCIA'},
      	{ id: 4, tipo: 'TARJETA' },
      ],

      dialogConfirmaCorreo:'',

      beca: null,
      pagoRealizao:0,

      pagosCursos:[],

      myState2: {
        pdf:         null,
        currentPage: 1,
        zoom:        2
      },
      solcitaFactura:1,
      saldoFactura: 0,
      descuentoRecomendados:[],
      descRecomienda:0,
      descRecomiendaSaldo:0,
      descuentosEspeciales:[],
      noPago:false,
      posicionHermano: 0,
      descuentoHermanos: 0,
      dialogSiguientepago: false,
      aut_clave_rastreo:null,
			folio_operacion:null,
			cuenta:null,
      celularWhatsApp: '',
    }),

    computed: {

    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
      
    	extension() {
        return (this.file) ? this.file.name.split('.').pop() : '';
      },

      pagoFinal () {
        return parseFloat(this.total_a_pagar) + (this.totalBonoIaApp)
      },

      adeudo( ){
        const restante = this.pagoFinal - parseFloat(this.total_pagado)
        if( restante > 0 )
          return restante.toFixed(2)
        else
          return 0
      },

      columnas( ){

      	return ( 12 / this.hermanos.length  ).toFixed(0)

      }
    },

    watch: {
      alumno: {
        immediate: true,
        handler ( val ) {
          if ( !val ) return
          // WhatsApp recibo: deshabilitado temporalmente
          // if ( !this.celularWhatsApp ) {
          //   this.celularWhatsApp = this.inicializarCelularWhatsAppPago( val, '' )
          // }
        },
      },

      solcitaFactura ( val ){
      	return 0
      },

      archivos( val ){
        this.total_pagado       = 0
        this.isPracticaja       = false
        this.isTransferencia    = false
        this.isSeven            = false
        this.isOXXO             = false
        this.isWeb              = false
        this.isTarjeta          = false
        this.isDirectoBancoBBVA = false
        this.isDirectoBANREGIO  = false
        if( !val ){ this.vistaPrevia = null } 
      },

      tipo_pago( val ){
        this.total_pagado = 0
      },

      posicionHermano( ){
        this.getPrecioPagar()
      },
    },

    async created () {
    	await this.getPrecioPagar( )
    },


    methods: {
      getPrecioPagar( ) {

        let grupo = this.steppers.grupo.grupoActual

      	this.cargar = true
      	this.grupos = []

      	const payload = {
      		id_alumno:        this.alumno.id_alumno,
      		grupoSiguiente:   grupo,
          hermanos:         false,
          factura:          true,
          unidad_negocio:   this.alumno.unidad_negocio
      	}

        return this.$http.post('inscripciones.calcular.factura', payload).then(response=>{

        	console.log( response.data.total_a_pagar )

        	this.precio_inicial         = response.data.precio_inicial
					this.descuento              = response.data.descuento
					this.total_a_pagar          = response.data.total_a_pagar
					this.beca                   = response.data.beca 
          this.pago_anterior          = response.data.pago_anterior 
          this.saldoFavor             = response.data.saldoFavor 
          this.tieneSaldoFavor        = response.data.tieneSaldoFavor 
          this.pagosCursos            = response.data.pagosCursos
          this.descuentoRecomendados  = response.data.descuentoRecomendados
          this.descRecomienda         = response.data.descRecomienda
          this.descRecomiendaSaldo    = response.data.descRecomiendaSaldo || 0
          this.descuentosEspeciales   = response.data.descuentosEspeciales
          this.iva                    = response.data.iva
          this.aplicarBonoIaAppDesdeRespuesta( response.data )
        	this.cargar = false

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      seleccionarAlumno( value ){

        let payload = {
          grupo: value, 
          hermanos: false
        }

      	this.$emit('alumnoSeleccionado', value )
      },

      realizarPago( data ){
        return new Promise((resolve,reject)=>{
          this.$http.post('registrar.grupo.alumno', data ).then( response => {
          if ( this.manejarRespuestaPagoIdempotente( response ) ) { resolve(response.data); return }
            // Convertir el monto en texto

            this.url = axios.defaults.baseURL + 'recibo-pago/' + response.data.ingreso.id + '.pdf'

            window.open( this.url )

            resolve('Inscrito correctamente')
          }).catch( error =>{
					if ( this.manejarErrorPagoDuplicado( error ) ) { reject( error ); return }

            reject( error )
          }).finally( () => { this.cargar = false })
        })
      },

      grabarImagen( ){
        return new Promise((resolve,reject)=>{
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo
          formData.append("file", this.file);

          this.$http.post("grabar.comprobante", formData).then( response => {
            resolve( response.data ) 
          }).catch( error =>{
            reject( error )
          }).finally( () => { this.cargar = false })
        })
      },

      async procesarPago( ){

      	this.sincronizarEmailReciboAlumno( this.alumno )
      	const errorContacto = this.validarContactoReciboPago( this.alumno.email )
      	if ( errorContacto ) {
      		return this.validarErrorDirecto( errorContacto )
      	}

      	if ( this.celularReciboInformado( this.celularWhatsApp ) && !this.confirmarWhatsAppReciboActivo() ) {
      		return
      	}

      	if( !this.beca && this.total_pagado <= 0 ){
      		return this.validarErrorDirecto('No puedes ingresar un pago en 0')
      	}

      	if ( !this.validarMontoCapturadoVsComprobante() ) {
      		return
      	}

      	this.cargar = true

      	if( this.tipo_pago != 1 && ( !this.aut_clave_rastreo || !this.folio_operacion || !this.cuenta )){

      		return this.validarErrorDirecto('Favor de llenar todos los datos del alumno')

      	}

      	// Nombre del archivo que se guardo 
      	let nombre_archivo = {nombre:''}

      	// Solo es es imagen, si no, se va vacío
      	if( this.tipo_pago != 1 ){
      		nombre_archivo = await this.grabarImagen( ).then( response => response ).catch( error => { return this.validarError(error) })
      	}

      	// El curso se debe guardar por que es NI
        let guardarCurso = true

        // Limpiar la cadena de cáracteres
        this.texto_completo = this.texto_completo.replace(/[∀,∂,∃,∄,∅,∆,∇,∈,∉,∊,∋,∌,∍,∎,∏,∐,∑,∓,∔,∖,√,∛,∜,∝,∞,∟,∠,∡,∢,∣,∤,∥,∦,∧,∨,∩,∪,∫,∬,∭,∮,∯,∰,∱,∲,∳,∴,∵,∶,∷,∸,∹,∺,∻,∼,∽,∾,∿,≀,≁,≂,≃,≄,≅,≆,≇,≈,≉,≊,≋,≌,≍,≎,≏,≐,≑,≒,≓,≔,≕,≖,≗,≘,≙,≚,≛,≜,≝,≞,≟,≠,≡,≢,≣,≤,≥,≦,≧,≨,≩,≪,≫,≬,≭,≮,≯,≰,≱,≲,≳,≴,≵,≶,≷,≸,≹,≺,≻,≼,≽,≾,≿,•,ЗУЗ,З,У,ф,₴,#,*,:,$,.,/]/g,' ')

        const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};

        this.texto_completo  = this.texto_completo.split('').map( letra => acentos[letra] || letra).join('').toString();


      	const payload = {
          idempotency_key            : this.generarIdempotencyKeyPago(),
          monto_comprobante           : this.monto_imagen,
          adeudo                     : parseFloat(this.adeudo),
			    base_path                  : null,
			    comentarios                : '',
          descRecomienda             : this.descRecomienda,
			    descuento                  : this.descuento - parseFloat(this.descuentoHermanos) ,
          descuentoRecomendados      : this.descuentoRecomendados,
          descuentosEspeciales       : this.descuentosEspeciales,
          grupo                      : this.steppers.grupo.grupoActual.grupo,
          guardarCurso,
			    id_alumno                  : this.alumno.id_alumno,
			    id_ciclo                   : this.steppers.grupo.grupoActual.id_ciclo,
          id_curso                   : this.steppers.grupo.grupoActual.id_curso,
			    id_descuento_pronto_pago   : null,
			    id_forma_pago              : this.tipo_pago,
          id_grupo                   : this.steppers.grupo.grupoActual.id_grupo,
			    id_plantel_ingreso         : this.getdatosUsuarioERPERP.id_plantel,
			    id_tipo_descuento          : null,
			    id_tipo_ingreso            : 2,
			    id_tipo_inscripcion        : this.total_pagado >= this.total_a_pagar ? 2 : 3,
			    id_usuario_ultimo_cambio   : this.getdatosUsuarioERPERP.iderp,
          idbecas                    : this.beca ? this.beca.id : 0,
			    monto_adeudo_grupo         : 0,
			    monto_descuento_grupo      : parseFloat( this.descuento ) - parseFloat(this.descuentoHermanos),
			    monto_pagado_total         : parseFloat(this.total_pagado ),
			    monto_saldo_favor          : 0,
          nuevoSaldoFavor            : 0,
			    pago_completado_sn         : this.total_pagado >= (parseFloat(this.total_a_pagar) - parseFloat(this.pago_anterior) + (this.totalBonoIaApp)) ? 1 : 0,
			    precio_curso               : this.precio_inicial,
			    precio_grupo_con_descuento : parseFloat( this.total_a_pagar ) + parseFloat( this.pago_anterior ) + (this.totalBonoIaApp),
			    precio_grupo_sin_descuento : this.precio_inicial,
          saldoFavor                 : 0,
          solcitaFactura             : this.solcitaFactura,
          ...this.payloadBonoIaApp(),
          tieneSaldoFavor            : this.tieneSaldoFavor,
          texto_completo             : this.texto_completo,
          tipoAlumno                 : this.alumno.tipoAlumno,
          total_pagado_alumno        : (parseFloat(this.precio_inicial) + parseFloat(this.saldoFactura) + (this.totalBonoIaApp)),
			    url_foto                   : nombre_archivo.nombre,
          pago_final_grupo           : parseFloat( this.pago_anterior ) + parseFloat(this.total_pagado ),
          folioOperacion             : this.folioOperacion,
          cuentaEscuela              : this.cuentaEscuela ? this.cuentaEscuela.replace(/\u26AB/g, '') : '',
          autorizacion               : this.autorizacion,
          aut_clave_rastreo          : this.aut_clave_rastreo,
					folio_operacion            : this.folio_operacion,
					cuenta                     : this.cuenta,
          email                      : this.normalizarEmailRecibo( this.alumno.email ),
				}

				this.$http.post('registrar.grupo.alumno', payload ).then( async response => {
          if ( this.manejarRespuestaPagoIdempotente( response ) ) return
          this.cargar = false

          this.tipo_pago = 1


          // Convertir el monto en texto
          this.pagoRealizao = response.data.ingreso.id
          let url = axios.defaults.baseURL + 'recibo-pago/' + this.pagoRealizao + '.pdf'
          window.open(url, '_blank');
          // this.dialogConfirmaCorreo = true
          await this.enviarComprobante( )

          this.dialogAddAlumno.estatus = false


				}).catch( error =>{
					if ( this.manejarErrorPagoDuplicado( error ) ) return

					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
      },

      enviarComprobante( ){

        const payload = {
          folio:                  this.pagoRealizao,
          alumno:                 this.alumno.nombre,
          matricula:              this.alumno.matricula,
          plantel:                this.getdatosUsuarioERPERP.plantel,
          ciclo:                  this.steppers.grupo.grupoActual.ciclo,
          curso:                  this.steppers.grupo.grupoActual.curso,
          cantidad_recibida:      this.total_pagado,
          cantidad_letra:         convertir.NumerosALetras(this.total_pagado).toUpperCase(),
          descuento_pronto_pago:  this.descuento,
          adeudo:                 this.adeudo,
          saldo_favor:            this.nuevoSaldoFavor,
          id_alumno:              this.alumno.id_alumno,
          email:                  this.normalizarEmailRecibo( this.alumno.email ),
          // celular:                this.celularWhatsApp, // WhatsApp recibo deshabilitado temporalmente
          twilio_asignado:        this.alumno.twilio_asignado || null,
          unidad_negocio:         this.alumno.unidad_negocio,
          fecha_pago:             this.fechapago,
          recepcion:              this.getdatosUsuarioERPERP.nombre_completo,
          solcitaFactura:         this.solcitaFactura
        }

        this.cargar = true
        return this.$http.post('actualizar.correo.alumno', payload ).then( response => {

          this.sincronizarEmailReciboAlumno( this.alumno )
          this.validarSuccess(response.data.message)

        }).catch( error =>{
         this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      cancelar( ){
        this.dialogSiguientepago = false
        this.$emit('terminarProceso')
      }
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>